<template>
    <div v-if="isActive"><slot></slot></div>
</template>

<script>
export default {
    props: {
        name: { required: true },
        icon: String,
        selected: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return { isActive: false };
    },
    computed: {
        url() {
            return "#" + this.name.toLowerCase().replace(/ /g, "-");
        }
    },
    mounted() {
        this.isActive = this.selected;
    },
}
</script>